module.exports = "pegasus_template/assets/col_1.png";